export const STATUS_HOLDED = 'holded';
export const STATUS_SHIPPED = 'shipped';
export const STATUS_CANCELED = 'canceled';
export const STATUS_CLOSED = 'closed';
export const STATUS_RECEIVED = 'order_received';
export const STATUS_PENDING = 'pending';
export const STATUS_WAITING_FOR_GRACE_PERIOD = 'waiting_for_grace_period';
export const STATUS_LABEL_ON_HOLD = 'On Hold';
export const STATUS_LABEL_SHIPPED = 'Shipped';
export const STATUS_LABEL_CANCELED = 'Canceled';
export const STATUS_LABEL_ORDER_RECEIVED = 'Order Received';
export const STATUS_LABEL_PROCESSING = 'Processing';

export const GRACE_PERIOD_STATUSES = [STATUS_RECEIVED, STATUS_PENDING, STATUS_WAITING_FOR_GRACE_PERIOD];
export const CANCELED_ORDER_STATUSES = [STATUS_CANCELED, STATUS_CLOSED];

export const GIFT_CARD_SKU = 'email-giftcard';
